import { configureStore } from '@reduxjs/toolkit';
// 引入各个slice的reducer
import userReducer from './slices/userSlice';
import roleReducer from './slices/roleSlice';
import permissionReducer from './slices/permissionSlice';
import userVerificationReducer from './slices/userVerificationSlice';
import businessVerificationReducer from './slices/businessVerificationSlice';
import taskReducer from './slices/taskSlice';
import orderReducer from './slices/orderSlice';
import transactionReducer from './slices/transactionSlice';
import withdrawReducer from './slices/withdrawSlice';
import prechargeOrderReducer from './slices/prechargeOrderSlice';
import paymentReducer from './slices/paymentSlice';
import paymentOrderReducer from './slices/paymentOrderSlice';
import accompanyShoppingOrderReducer from './slices/accompanyShoppingOrderSlice';
import accompanyShoppingProviderReducer from './slices/accompanyShoppingProviderSlice';
import accompanyShoppingReviewReducer from './slices/accompanyShoppingReviewSlice';
import accompanyShoppingProviderApplicationReducer from './slices/accompanyShoppingProviderApplicationSlice';
import freezeRecordReducer from './slices/freezeRecordSlice';
import chatSessionReducer from './slices/chatSessionSlice';
import chatMessageReducer from './slices/chatMessageSlice';
import notificationReducer from './slices/notificationSlice';
import userDeviceReducer from './slices/userDeviceSlice';
import userDeviceHistoryReducer from './slices/userDeviceHistorySlice';
import logReducer from './slices/logSlice';
import loginRecordReducer from './slices/loginRecordSlice';
import userProfileReducer from './slices/userProfileSlice';
import userAccountReducer from './slices/userAccountSlice';
import userLevelReducer from './slices/userLevelSlice';
import userSkillReducer from './slices/userSkillSlice';
import userQuotaAccountReducer from './slices/userQuotaAccountSlice';
import userQuotaUsageLogReducer from './slices/userQuotaUsageLogSlice';
import statisticsReducer from './slices/statisticsSlice';
import userStatisticsReducer from './slices/userStatisticsSlice';
import taskStatisticsReducer from './slices/taskStatisticsSlice';
import feedbackReducer from './slices/feedbackSlice';
import shopReducer from './slices/shopSlice';
import productReducer from './slices/productSlice';
import logisticsReducer from './slices/logisticsSlice';
import shippingReducer from './slices/shippingSlice';
import qualityReducer from './slices/qualitySlice';
import purchaseAndDynamicsReducer from './slices/purchaseAndDynamicsSlice';
import customServiceRequestReducer from './slices/customServiceRequestSlice';
import customServiceOrderReducer from './slices/customServiceOrderSlice';
import accompanyShoppingAfterSaleReducer from './slices/accompanyShoppingAfterSaleSlice';
import afterSaleServiceReducer from './slices/afterSaleServiceSlice';
import { customServiceReducer, accompanyServiceReducer } from './slices/customServiceSlice';
import shoppingCartReducer from './slices/shoppingCartSlice';
import userAddressReducer from './slices/userAddressSlice';
import likeRecordReducer from './slices/likeRecordSlice';
import interactionMessageReducer from './slices/interactionMessageSlice';
import goodsCategoryReducer from './slices/goodsCategorySlice';
import goodsReducer from './slices/goodsSlice';
import goodsCategoryListReducer from './slices/goodsCategoryListSlice';
import goodsAuditQueueReducer from './slices/goodsAuditQueueSlice';
import tabsReducer from './slices/tabsSlice';
import goodsCommentReducer from './slices/goodsCommentSlice';
import merchantEntryApplicationReducer from './slices/merchantEntryApplicationSlice';
import merchantQualificationReducer from './slices/merchantQualificationSlice';
import merchantCertificationReducer from './slices/merchantCertificationSlice';
import merchantBusinessInfoReducer from './slices/merchantBusinessInfoSlice';
import logisticsCompanyReducer from './slices/logisticsCompanySlice';
import afterSaleServiceConfigReducer from './slices/afterSaleServiceConfigSlice';
import freightTemplateReducer from './slices/freightTemplateSlice';
import qualityInspectionReducer from './slices/qualityInspectionSlice';
import complaintFeedbackReducer from './slices/complaintFeedbackSlice';
import complaintTypeConfigReducer from './slices/complaintTypeConfigSlice';
import buyingPostReducer from './slices/buyingPostSlice';
import buyingPostAuditQueueReducer from './slices/buyingPostAuditQueueSlice';
import momentPostAuditQueueReducer from './slices/momentPostAuditQueueSlice';
import momentPostReducer from './slices/momentPostSlice';
import goodsSpecTypeReducer from './slices/goodsSpecTypeSlice';
import fileReducer from './slices/fileSlice';
import shippingCenterReducer from './slices/shippingCenterSlice';
import regionReducer from './slices/regionSlice';
import senderInfoReducer from './slices/senderInfoSlice';
import freightTemplateRuleReducer from './slices/freightTemplateRuleSlice';
import afterSalesTypeReducer from './slices/afterSalesTypeSlice';
import accompanyShoppingLocationReducer from './slices/accompanyShoppingLocationSlice';
import helpCenterArticleReducer from './slices/helpCenterArticleSlice';
import helpCenterCategoryReducer from './slices/helpCenterCategorySlice';
import platformSalesOrderReducer from './slices/platformSalesOrderSlice';
import platformSalesProductReducer from './slices/platformSalesProductSlice';
import platformSalesShippingReducer from './slices/platformSalesShippingSlice';
import platformSalesReturnReducer from './slices/platformSalesReturnSlice';
import systemConfigReducer from './slices/systemConfigSlice';
import bannerReducer from './slices/bannerSlice';
import profileReducer from './slices/profileSlice';
import systemOperationLogReducer from './slices/systemOperationLogSlice';
import systemErrorLogReducer from './slices/systemErrorLogSlice';
import articleReducer from './slices/articleSlice';
import articleTypeReducer from './slices/articleTypeSlice';
import articleRedeemCodeReducer from './slices/articleRedeemCodeSlice';
import storeVisitStatisticsReducer from './slices/storeVisitStatisticsSlice';
import jadeIdentificationArticleReducer from './slices/jadeIdentificationArticleSlice';
import jadeIdentificationCategoryReducer from './slices/jadeIdentificationCategorySlice';
import userArticleRedeemReducer from './slices/userArticleRedeemSlice';
import jadeIdentificationServiceReducer from './slices/jadeIdentificationServiceSlice';
import jadeIdentificationOrderReducer from './slices/jadeIdentificationOrderSlice';
// 配置store
const store = configureStore({
  reducer: {
    user: userReducer,
    role: roleReducer,
    permission: permissionReducer,
    userVerification: userVerificationReducer,
    businessVerification: businessVerificationReducer,
    task: taskReducer,
    order: orderReducer,
    transaction: transactionReducer,
    withdraw: withdrawReducer,
    prechargeOrder: prechargeOrderReducer,
    payment: paymentReducer,
    paymentOrder: paymentOrderReducer,
    accompanyShoppingOrder: accompanyShoppingOrderReducer,
    accompanyShoppingProvider: accompanyShoppingProviderReducer,
    accompanyShoppingReview: accompanyShoppingReviewReducer,
    accompanyShoppingProviderApplication: accompanyShoppingProviderApplicationReducer,
    freezeRecord: freezeRecordReducer,
    chatSession: chatSessionReducer,
    chatMessage: chatMessageReducer,
    notification: notificationReducer,
    userDevice: userDeviceReducer,
    userDeviceHistory: userDeviceHistoryReducer,
    log: logReducer,
    loginRecord: loginRecordReducer,
    userProfile: userProfileReducer,
    userAccount: userAccountReducer,
    userLevel: userLevelReducer,
    userSkill: userSkillReducer,
    userQuotaAccount: userQuotaAccountReducer,
    userQuotaUsageLog: userQuotaUsageLogReducer,
    statistics: statisticsReducer,
    userStatistics: userStatisticsReducer,
    taskStatistics: taskStatisticsReducer,
    feedback: feedbackReducer,
    shop: shopReducer,
    product: productReducer,
    logistics: logisticsReducer,
    shipping: shippingReducer,
    quality: qualityReducer,
    purchaseAndDynamics: purchaseAndDynamicsReducer,
    customService: customServiceReducer,
    accompanyService: accompanyServiceReducer,
    customServiceRequest: customServiceRequestReducer,
    customServiceOrder: customServiceOrderReducer,
    accompanyShoppingReview: accompanyShoppingReviewReducer,
    accompanyShoppingAfterSale: accompanyShoppingAfterSaleReducer,
    afterSaleService: afterSaleServiceReducer,
    shoppingCart: shoppingCartReducer,
    userAddress: userAddressReducer,
    likeRecord: likeRecordReducer,
    interactionMessage: interactionMessageReducer,
    goodsCategory: goodsCategoryReducer,
    goods: goodsReducer,
    goodsCategoryList: goodsCategoryListReducer,
    goodsAuditQueue: goodsAuditQueueReducer,
    tabs: tabsReducer,
    goodsComment: goodsCommentReducer,
    merchantEntryApplication: merchantEntryApplicationReducer,
    merchantQualification: merchantQualificationReducer,
    merchantCertification: merchantCertificationReducer,
    merchantBusinessInfo: merchantBusinessInfoReducer,
    logisticsCompany: logisticsCompanyReducer,
    afterSaleServiceConfig: afterSaleServiceConfigReducer,
    freightTemplate: freightTemplateReducer,
    qualityInspection: qualityInspectionReducer,
    complaintFeedback: complaintFeedbackReducer,
    complaintTypeConfig: complaintTypeConfigReducer,
    buyingPost: buyingPostReducer,
    buyingPostAuditQueue: buyingPostAuditQueueReducer,
    momentPostAuditQueue: momentPostAuditQueueReducer,
    momentPost: momentPostReducer,
    goodsSpecType: goodsSpecTypeReducer,
    fileUpload: fileReducer,
    shippingCenter: shippingCenterReducer,
    region: regionReducer,
    senderInfo: senderInfoReducer,
    freightTemplateRule: freightTemplateRuleReducer,
    afterSalesType: afterSalesTypeReducer,
    accompanyShoppingLocation: accompanyShoppingLocationReducer,
    helpCenterArticle: helpCenterArticleReducer,
    helpCenterCategory: helpCenterCategoryReducer,
    platformSalesOrder: platformSalesOrderReducer,
    platformSalesProduct: platformSalesProductReducer,
    platformSalesShipping: platformSalesShippingReducer,
    platformSalesReturn: platformSalesReturnReducer,
    systemConfig: systemConfigReducer,
    banner: bannerReducer,
    profile: profileReducer,
    systemOperationLog: systemOperationLogReducer,
    systemErrorLog: systemErrorLogReducer,
    article: articleReducer,
    articleType: articleTypeReducer,
    articleRedeemCode: articleRedeemCodeReducer,
    storeVisitStatistics: storeVisitStatisticsReducer,
    jadeIdentificationArticle: jadeIdentificationArticleReducer,
    jadeIdentificationCategory: jadeIdentificationCategoryReducer,
    userArticleRedeem: userArticleRedeemReducer,
    jadeIdentificationService: jadeIdentificationServiceReducer,
    jadeIdentificationOrder: jadeIdentificationOrderReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store; 